import classNames from 'classnames/bind';
import styles from './DropdownMenu.module.scss';
import Select, { components } from 'react-select';
import Icon from '../Icon/Icon';
import { IconName } from '../Icon/utils/types';

const cx = classNames.bind(styles);

const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <Icon
        name={IconName.ArrowDown}
        className={cx('dropdown-menu__arrow-icon')}
        width={12}
        height={16}
      />
    </components.DropdownIndicator>
  );
};

export interface DropdownMenuOption {
  value: string;
  label: string;
}

export interface DropdownMenuProps {
  options: DropdownMenuOption[];
  value?: DropdownMenuOption;
  defaultValue?: DropdownMenuOption;
  placeholder?: string;
  isSearchable?: boolean;
  isDisabled?: boolean;
  className?: string;
  onChange?: (option: DropdownMenuOption) => void;
}

const DropdownMenu = (props: DropdownMenuProps) => {
  const {
    options,
    value,
    defaultValue,
    placeholder,
    isSearchable = false,
    isDisabled,
    className,
    onChange,
  } = props;

  return (
    <div className={cx('dropdown-menu', className)}>
      <Select
        classNames={{
          control: (state: any) =>
            cx('dropdown-menu__control', {
              'dropdown-menu__control--focused': state.isFocused,
            }),
          valueContainer: () => cx('dropdown-menu__value-container'),
          singleValue: () => cx('dropdown-menu__single-value'),
          input: () => cx('dropdown-menu__input'),
          dropdownIndicator: () => cx('dropdown-menu__dropdown-indicator'),
          menu: () => cx('dropdown-menu__menu'),
          option: (state: any) =>
            cx('dropdown-menu__option', {
              'dropdown-menu__option--focused': state.isFocused,
              'dropdown-menu__option--selected': state.isSelected,
            }),
        }}
        options={options}
        value={value}
        defaultValue={defaultValue}
        isSearchable={isSearchable}
        onChange={onChange}
        components={{ DropdownIndicator }}
        placeholder={placeholder}
        isDisabled={isDisabled}
      />
    </div>
  );
};

export default DropdownMenu;
